<script setup lang="ts">
const currentArticle = inject(keys.currentArticle)

const url = useRequestURL()

const href = computed(() => url.href.replace('http://', 'https://'))

const shareData = computed(() => ({
  title: currentArticle?.title,
  url: href.value,
}))

const canShare = computed(
  () =>
    import.meta.client &&
      navigator &&
      !!navigator.share &&
      !!navigator.canShare &&
      navigator.canShare(shareData.value),
)

async function share() {
  if (canShare.value) {
    try {
      await navigator.share(shareData.value)
    } catch {
      // Do nothing
    }
  }
}

const btnClass = 'bg-green-50 text-beige-10 hover:bg-green-30'
</script>

<template>
  <div v-if="currentArticle" class="flex items-center justify-end gap-2">
    <span class="mr-2 font-normal text-green-50 uppercase">Del artikkelen:</span>
    <UiSocialLink
      provider="facebook"
      :href="`https://www.facebook.com/sharer/sharer.php?u=${href}`"
      label="Del på Facebook"
      :class="btnClass"
    />
    <UiSocialLink
      provider="linkedin"
      :href="`https://www.linkedin.com/cws/share?url=${href}`"
      label="Del på LinkedIn"
      :class="btnClass"
    />
    <ClientOnly>
      <UButton
        v-if="canShare"
        :class="btnClass"
        class="rounded-full"
        icon="fa7-solid:share"
        aria-label="Del artikkelen"
        @click="share"
      />
    </ClientOnly>
  </div>
</template>
